module.exports = __webpack_public_path__ + "img/cda-platform-min.2470c0fc.png";